module.exports = __webpack_public_path__ + "img/back_37.354ca96b.svg";